import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NotificationsService } from 'angular2-notifications';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { finalize, take } from 'rxjs';
import { UserApiService } from 'src/app/core/services/api/user-api.service';
import { ErrorHandlingService } from 'src/app/core/services/error-handling.service';
import { ValidationService } from 'src/app/core/services/validation.service';

@Component({
  selector: 'app-update-user-password-modal',
  templateUrl: './update-user-password-modal.component.html',
  styleUrls: ['./update-user-password-modal.component.scss'],
})
export class UpdateUserPasswordModalComponent implements OnInit {
  form!: FormGroup;
  isSubmitLoading: boolean = false;
  isPasswordVisible: boolean = false;

  constructor(
    private fb: FormBuilder,
    private notificationsService: NotificationsService,
    private dynamicDialogConfig: DynamicDialogConfig,
    protected dynamicDialogRef: DynamicDialogRef,
    private userApiService: UserApiService,
    private validationService: ValidationService,
    private errorHandlingService: ErrorHandlingService
  ) {}

  ngOnInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.form = this.fb.group(
      {
        password: [
          '',
          Validators.compose([
            Validators.required,
            Validators.minLength(8),
            this.validationService.patternValidator(
              this.validationService.passwordCapitalLetterPatter,
              { notHasCapitalCase: true }
            ),
            this.validationService.patternValidator(
              this.validationService.passwordSmallLetterPatter,
              { notHasSmallCase: true }
            ),
            this.validationService.patternValidator(
              this.validationService.passwordNumbersPattern,
              { notHasNumber: true }
            ),
            this.validationService.patternValidator(
              this.validationService.passwordSpecialCharPattern,
              { notHasSpecialCharacters: true }
            ),
          ]),
        ],
        password_confirmation: ['', Validators.required],
      },
      { validators: this.validationService.matchingPasswords() }
    );
  }

  handleUpdatePassword(): void {
    this.isSubmitLoading = true;
    const { userId } = this.dynamicDialogConfig.data;
    const body = this.form.value;
    this.userApiService
      .updateUserPassword(userId, body)
      .pipe(
        take(1),
        finalize(() => (this.isSubmitLoading = false))
      )
      .subscribe({
        next: (res) => {
          this.notificationsService.success('', res.message);
          this.dynamicDialogRef.close();
        },
        error: (err) => {
          this.errorHandlingService.errorHandling(err);
        },
      });
  }

  showHidePassword(passField: any, toggle: any) {
    this.isPasswordVisible = !this.isPasswordVisible;
    passField.type = this.isPasswordVisible ? 'text' : 'password';
    toggle.src = this.isPasswordVisible
      ? './assets/images/eye.svg'
      : './assets/images/eye-slash.svg';
  }
}
